module.exports = __webpack_public_path__ + "static/media/ddk-mainslide-01.b93fc024.jpg";